import React from 'react';
import { pure, compose, withHandlers } from 'react-recompose';
// features
import CarrierScorecards from '../../carrier-scorecards';
// helpers/constants
import * as G from '../../../helpers';
// ui
import { MainDarkActionButton } from '../../../ui';
//////////////////////////////////////////////////

const ShowScorecards = ({ handleShowScorecards }) => (
  <MainDarkActionButton onClick={handleShowScorecards}>
    {G.getWindowLocale('titles:show-scorecards', 'Show Scorecards')}
  </MainDarkActionButton>
);

const enhance = compose(
  withHandlers({
    handleShowScorecards: (props) => () => {
      const { openModal, branchGuid, carrierGuid, carrierName } = props;

      const component = (
        <CarrierScorecards carrierGuid={carrierGuid} carrierName={carrierName} divisionGuid={branchGuid} />
      );

      const options = {
        p: '0px',
        component,
        options: {
          width: '90vw',
          maxWidth: 1550,
          minHeight: 600,
          overflow: 'auto',
          maxHeight: '90vh',
          withCloseIcon: true,
          title: G.getWindowLocale('titles:score-cards', 'Score Cards'),
        },
      };

      return openModal(options);
    },
  }),
  pure,
);

export default enhance(ShowScorecards);
